export interface IConsentAction {
  id: number;
  user_id: number;
  study_consent_id: number;
  reviewer_id: number;
  comment: string;
  status: string;
  user_study_milestone_id: number;
}
